import { Component, Input } from '@angular/core';
import { ToastButtonConfig, ToastConfig } from '@app/modules/toasts/models/interfaces/toast.interfaces';
import { ToastService } from '@app/modules/toasts/services/toast.service';
import { faCircleInfo, faXmarkLarge, IconDefinition } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'fdx-toast',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    standalone: false
})
export class ToastComponent {

    readonly closeIcon: IconDefinition = faXmarkLarge;
    readonly infoIcon: IconDefinition = faCircleInfo;

    @Input({required: true}) toast: ToastConfig;

    constructor(
        private readonly toastService: ToastService
    ) { }

    getToastTheme(toast: ToastConfig): string {
        if (toast.theme === 'downloading') {
            return 'toast-secondary';
        }
        return `toast-${toast.theme}`;
    }

    getIconTheme(toast: ToastConfig): string {
        if (toast.theme === 'downloading') {
            return 'text-secondary-500';
        }
        return `text-${toast.theme}-500`;
    }

    getButtonClasses(toast: ToastConfig, button: ToastButtonConfig, index: number): string[] {
        const classes: string[] = [];
        if (index === 0 && button.variant === 'link') {
            classes.push('ps-0');
        }

        if (toast.theme === 'downloading') {
            switch (button.variant) {
                case 'regular':
                    classes.push('btn-secondary');
                    break;
                case 'outline':
                    classes.push('btn-outline-secondary');
                    break;
                case 'link':
                    classes.push('btn-link text-secondary');
                    break;
                default:
                    classes.push('btn-secondary');
                    break;
            }
            return classes;
        }

        switch (button.variant) {
            case 'regular':
                classes.push(`btn-${toast.theme}`);
                break;
            case 'outline':
                classes.push(`btn-outline-${toast.theme}`);
                break;
            case 'link':
                classes.push(`btn-link text-${toast.theme}`);
                break;
            default:
                classes.push('btn-secondary');
                break;
        }
        return classes;
    }

    buttonClick(e: MouseEvent, button: ToastButtonConfig): void {
        if (typeof (button.callback) === 'function') {
            button.callback(e);
        }
    }

    onHidden(toast: ToastConfig): void {
        this.closeToast(toast.id);
    }

    closeToast(id: number): void {
        this.toastService.dismiss(id);
    }
}
